import * as Yup from "yup";
import {
  accountValidationSchemaFields,
  homeUserAccountValidationSchemaFields,
} from "../FormComponents/Validations";
import { AccountPayer } from "../types";
import { State } from "src/components/Premises";

export const claimFormValidationSchema = Yup.object().shape({
  siteSupervisor: Yup.string(),
  ...accountValidationSchemaFields("electricity", true),

  electricityLifeSupport: Yup.boolean()
    .nullable()
    .transform((value) => (value === undefined ? null : value))
    .default(null)
    .when(["electricityAccountPayer", "$state"], {
      is: (electricityAccountPayer: string, state: string) =>
        electricityAccountPayer === AccountPayer.COMPANY && state === State.VIC,
      then: (schema) =>
        schema.required(
          "Oops, you must let us know if someone at the property is  on life support."
        ),
      otherwise: (schema) => schema.notRequired(),
    }),
});

const claimDialogValidationFields = {
  requestingCompany: Yup.mixed().required("Please fill"),
  requestId: Yup.string().required("Please fill"),
};

export const homeUserClaimDialogValidationFields = {
  requestId: Yup.string().required("Please fill"),
};

export const homeUserClaimFormValidationFields = {
  electricityAccountPayer: Yup.string().required(
    "Please select who's responsible for the electricity account"
  ),
  ...homeUserAccountValidationSchemaFields("electricity", true),
  homeUserAgreeTerms: Yup.boolean().when(["electricityAccountPayer"], {
    is: (electricityAccountPayer: string) => {
      return electricityAccountPayer !== AccountPayer.SOMEONE_ELSE;
    },
    then: (schema) =>
      schema.isTrue("Oops, you must agree to the terms and conditions."),
    otherwise: (schema) => schema.notRequired(),
  }),
};

export const claimSearchRequestValidationSchema = Yup.object().shape({
  ...claimDialogValidationFields,
});

export const claimDialogValidationSchema = Yup.object().shape({
  ...claimDialogValidationFields,
});

export const homeUserClaimDialogValidationSchema = Yup.object().shape({
  ...homeUserClaimDialogValidationFields,
});

export const homeUserClaimFormValidationSchema = Yup.object().shape({
  ...homeUserClaimDialogValidationFields,
  ...homeUserClaimFormValidationFields,
});
